module.exports = __webpack_public_path__ + "fonts/jj2 lt.28c188d8.otf";